/* CPL ortak yardımcılar: window.CPL */
(() => {
  const CPL = (window.CPL = window.CPL || {});

  CPL.fetchConfig = (type = 'json', body) => ({
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    body: body ? JSON.stringify(body) : undefined,
  });

  CPL.debounce = (fn, wait = 300) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), wait);
    };
  };

  /* Yayınla / abone ol */
  const subscribers = {};
  CPL.subscribe = (event, cb) => {
    (subscribers[event] = subscribers[event] || []).push(cb);
    return () => (subscribers[event] = subscribers[event].filter((x) => x !== cb));
  };
  CPL.publish = (event, data) => (subscribers[event] || []).forEach((cb) => cb(data));
  CPL.events = { cartUpdate: 'cart-update', cartError: 'cart-error', variantChange: 'variant-change' };

  /* Odak tuzağı */
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), summary';
  let trap = {};
  CPL.trapFocus = (container, elementToFocus = container) => {
    const els = () => Array.from(container.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null || el === document.activeElement);
    CPL.removeTrapFocus();
    trap.keydown = (e) => {
      if (e.key !== 'Tab') return;
      const list = els();
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];
      if (!container.contains(document.activeElement) || document.activeElement === container) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', trap.keydown);
    (elementToFocus || container).focus({ preventScroll: true });
  };
  CPL.removeTrapFocus = (elementToFocus = null) => {
    if (trap.keydown) document.removeEventListener('keydown', trap.keydown);
    trap = {};
    if (elementToFocus) elementToFocus.focus({ preventScroll: true });
  };

  /* Para biçimi (₺1.849) */
  CPL.formatMoney = (cents) => {
    const value = (Number(cents) || 0) / 100;
    const hasDecimals = Math.round(value * 100) % 100 !== 0;
    return (
      '₺' +
      value.toLocaleString('tr-TR', { minimumFractionDigits: hasDecimals ? 2 : 0, maximumFractionDigits: 2 })
    );
  };

  /* Toast */
  CPL.toast = (detail) => {
    const el = document.querySelector('cpl-toast');
    if (el) el.show(detail);
  };

  /* Sepet: Cart AJAX API + Section Rendering API */
  CPL.cart = {
    sections: () =>
      Array.from(document.querySelectorAll('[data-cart-section]')).map((el) => el.dataset.cartSection),
    async request(url, body) {
      const sections = CPL.cart.sections();
      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }
      const res = await fetch(url, CPL.fetchConfig('javascript', body));
      let data;
      try {
        data = await res.json();
      } catch (e) {
        data = { status: res.status, message: window.cplStrings?.cartError, description: window.cplStrings?.cartError };
      }
      if (!res.ok || data.status || data.errors) {
        data.status = data.status || res.status;
        CPL.publish(CPL.events.cartError, data);
        throw data;
      }
      return data;
    },
    async add(items, source) {
      const data = await CPL.cart.request(window.routes.cart_add_url + '.js', { items });
      const cart = await CPL.cart.fetch();
      CPL.publish(CPL.events.cartUpdate, { source: source || 'add', cart, sections: data.sections, items: data.items || [data] });
      return { data, cart };
    },
    /* line: satır numarası (1'den başlar) ya da satır anahtarı (item.key) */
    async change(line, quantity, source) {
      const body = typeof line === 'string' ? { id: line, quantity } : { line, quantity };
      const data = await CPL.cart.request(window.routes.cart_change_url + '.js', body);
      CPL.publish(CPL.events.cartUpdate, { source: source || 'change', cart: data, sections: data.sections });
      return data;
    },
    async update(body, source) {
      const data = await CPL.cart.request(window.routes.cart_update_url + '.js', body);
      CPL.publish(CPL.events.cartUpdate, { source: source || 'update', cart: data, sections: data.sections });
      return data;
    },
    async fetch() {
      const res = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
      return res.json();
    },
  };

  /* Section HTML parçasını yerine koy */
  CPL.replaceFromHTML = (html, selector, target = document) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = doc.querySelector(selector);
    const dest = target.querySelector(selector);
    if (source && dest) dest.replaceWith(source);
    return source;
  };

  /* Sepet sayacı (header) */
  CPL.subscribe(CPL.events.cartUpdate, ({ cart }) => {
    if (!cart) return;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });
  });
})();

/* <cpl-toast> — sepete eklendi / kopyalandı bildirimi */
class CplToast extends HTMLElement {
  show({ text, image, type = 'info', action }) {
    clearTimeout(this.timer);
    this.querySelector('[data-toast-text]').textContent = text || '';
    const img = this.querySelector('[data-toast-image]');
    if (img) {
      img.hidden = !image;
      if (image) img.src = image;
    }
    const act = this.querySelector('[data-toast-action]');
    if (act) act.hidden = type !== 'cart';
    this.dataset.type = type;
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-visible'));
    this.timer = setTimeout(() => this.hide(), 4000);
  }
  hide() {
    this.classList.remove('is-visible');
    this.timer = setTimeout(() => (this.hidden = true), 200);
  }
  connectedCallback() {
    this.querySelector('[data-toast-close]')?.addEventListener('click', () => this.hide());
    this.querySelector('[data-toast-action]')?.addEventListener('click', () => {
      this.hide();
      document.querySelector('cart-drawer')?.open();
    });
  }
}
customElements.define('cpl-toast', CplToast);

/* <copy-button data-copy="..."> */
class CopyButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(this.dataset.copy);
        CPL.toast({ text: this.dataset.copiedText || window.cplStrings?.copied || 'Kopyalandı', type: 'copy' });
      } catch (e) {
        /* pano erişimi yoksa sessiz geç */
      }
    });
  }
}
customElements.define('copy-button', CopyButton);

/* <quantity-input> — − / adet / + */
class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.querySelectorAll('button[name]').forEach((btn) =>
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const prev = this.input.value;
        btn.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (prev !== this.input.value) this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      })
    );
    this.input.addEventListener('change', () => this.sync());
    this.sync();
  }
  sync() {
    const v = parseInt(this.input.value, 10);
    const min = parseInt(this.input.min || '0', 10);
    const max = this.input.max ? parseInt(this.input.max, 10) : null;
    const minus = this.querySelector('button[name="minus"]');
    const plus = this.querySelector('button[name="plus"]');
    if (minus && !this.hasAttribute('data-allow-zero')) minus.disabled = v <= min;
    if (plus) plus.disabled = max !== null && v >= max;
  }
}
customElements.define('quantity-input', QuantityInput);

/* <details-disclosure> — akordiyon: tek açık mod + aria */
class AccordionGroup extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-single')) return;
    this.addEventListener(
      'toggle',
      (e) => {
        if (!e.target.open) return;
        this.querySelectorAll('details[open]').forEach((d) => d !== e.target && (d.open = false));
      },
      true
    );
  }
}
customElements.define('accordion-group', AccordionGroup);

/* <modal-dialog> — genel modal / mobilde alttan sheet */
class ModalDialog extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-modal-close]').forEach((b) => b.addEventListener('click', () => this.close()));
    this.addEventListener('keyup', (e) => e.key === 'Escape' && this.close());
    this.querySelector('.overlay')?.addEventListener('click', () => this.close());
    if (this.id) {
      document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach((opener) =>
        opener.addEventListener('click', (e) => {
          e.preventDefault();
          this.open(opener);
        })
      );
    }
  }
  open(opener) {
    this._closing = false;
    this.opener = opener || document.activeElement;
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-open'));
    document.body.classList.add('overflow-hidden');
    CPL.trapFocus(this.querySelector('[role="dialog"]') || this);
    this.dispatchEvent(new CustomEvent('modal:open', { bubbles: true }));
  }
  close({ restoreFocus = true } = {}) {
    if (this.hidden || this._closing) return;
    this._closing = true;
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    CPL.removeTrapFocus(restoreFocus ? this.opener : null);
    setTimeout(() => {
      this.hidden = true;
      this._closing = false;
    }, 200);
    this.dispatchEvent(new CustomEvent('modal:close', { bubbles: true }));
  }
}
customElements.define('modal-dialog', ModalDialog);
